<asw-seatmap-pres [isdisplayContent]="isdisplayContent"></asw-seatmap-pres>
